import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import './css/PremiumCalCulatorStyles.scss';
import LangData from "../common/LangData";
import { isTokenExpired, clearAuthSession } from "../../utils/utils";
import { addLoginUser, setIsLogin } from "../../actions/Users";
import toast from "react-hot-toast";

const PolicyBuyButton = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  // Retrieve the token and user data
  const token = localStorage.getItem("authToken");
  const user = useSelector((state) => state?.user);

  const tokenExpired = isTokenExpired(token);
  if (tokenExpired && token) {
    clearAuthSession();
    if (user?.loginuser && Object.keys(user.loginuser).length > 0) {
      dispatch(addLoginUser({}));
      dispatch(setIsLogin(false));
    }
  }

  // Check if user is logged in and if the token is valid
  const isLoggedIn =
    token && !tokenExpired && user?.loginuser && Object.keys(user.loginuser).length > 0;

  // useEffect hook to initialize Bootstrap tooltips
  useEffect(() => {
    // Initialize Bootstrap tooltips after the component mounts
    const tooltipTriggerList = document.querySelectorAll(
      '[data-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  const handleClick = (e) => {
    if (!isLoggedIn) {
      e.preventDefault();
      toast("Please log in to submit your policy proposal", { icon: "ℹ️" });
      history.push("/login-office", { from: "/policy-buy" });
    }
  };

  return (
    <div
      className="tooltip_btn__area"
      data-toggle="tooltip"
      data-placement="top"
      title={
        !isLoggedIn ? "Please log in to submit your policy proposal" : ""
      }
    >
      <Link
        to={isLoggedIn ? "/policy-buy" : "/login-office"}
        onClick={handleClick}
        className="btn btn-buynow btn-primary policy-buy-btn btn__hover-effect"
        style={{
          cursor: "pointer",
        }}
      >
        {/* proposal_submission_text */}
        <LangData keyname="label_proposal_submission" />
      </Link>
    </div>
  );
};

export default PolicyBuyButton;
